import { getPreload } from "./preload";

export const getFlag = (flagName: string): boolean => {
  const flags = getPreload()["flags"] ?? {};
  return flags[flagName] ?? false;
};
